import { Router, Params, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import { LoginService } from './login.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { setting } from '../../../../setting';
import { HttpErrorResponse } from '@angular/common/http';
import { TurnstileComponent } from '../../shared/turnstile/turnstile.component';
import { NotificationService } from '../../shared/notifications/notification.service';
import { ClientSetting } from '../../interfaces/clientSetting.interface';
import { HeroVariant } from '../hero/hero.component';

@Component({
	selector: 'login',
	templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit{

  @Input() clientSetting: ClientSetting | null = null;
  @Input() variant: HeroVariant = 'classic';

  @Output() loginShowModal = new EventEmitter();
  @Output() userDisabledEmitter = new EventEmitter<boolean>();

	@ViewChild(TurnstileComponent) turnstile?: TurnstileComponent;
  @ViewChild('ModalSelectAgency', { read: TemplateRef }) ModalSelectAgency: string | TemplateRef<any> | (new (...args: any[]) => any) | undefined;

	public turnstileEnabled = setting.turnstileEnabled;
	public turnstileSiteKey = setting.turnstileSiteKey;
	public turnstileToken: string | null = null;
	public getClientsSettingAppAuth: ClientSetting | null = null;
	public sectionLogin: any;
	public load!: boolean;
	public modules:any;
	public urls: any;
	public loginForm!: FormGroup;
	public activeform : any;
	public dbAgency: any;
	modalRef!: BsModalRef;
	public agencysUser: any;
	apiBookingUrl: any;
  showPassword: boolean = false;
	public data: any;
  public actionRecover!: string;
  showModal: boolean = false;
  public loadingResetPass: boolean = true;
  public twoFactorRequired: boolean = false;
  public twoFactorCode: string = '';
  public twoFactorError: boolean = false;

  private pendingToken: string | null = null;

  private turnstileResolve: ((token: string) => void) | null = null;
  private turnstileReject: ((error: unknown) => void) | null = null;


	constructor(
              private _loginService: LoginService,
              public _router:Router,
              public activatedRoute: ActivatedRoute,
              private fb : FormBuilder,
              private modalService: BsModalService,
              public notificationService: NotificationService,
             ){}


	ngOnInit () {

    this.apiBookingUrl  = setting.apiBookingUrl
		this.getClientsSettingAppAuth = this.clientSetting;
		this.load = false;
		this.activeform = {login: true, recoverpass: false};

		this.loginForm = this.fb.group({
	      email: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]],
	      password: ['', [Validators.required, Validators.minLength(6)]]
	    });

		this.initUser();
	}

	openModal() {
		setTimeout(() => {
		  this.modalRef = this.modalService.show(this.ModalSelectAgency,
			{ class: 'modal-lg',
			ignoreBackdropClick: true,
			keyboard: false
		});
		}, 500);
	}

	getAgency(_data: any, data: any) {
		this._loginService.getAgency(data).subscribe(
			(response:any) => {
			//    this.dbAgency = response.data;
					if (response.length > 1 ) { // posee mas de una agencia
						this.agencysUser = response;
						this.data = _data;
					this.openModal();
					} else {
						this._router.navigate(['/select', {}]);  // redirects to home with toast
						///this.dbAgency = response.data[0].name;
					}
			},
			error => {
				this.load = false;
				//this.logger.log(error);
			}
		);
	}

// En tu componente (login.component.ts)
async onLogin() {

  if(!this.loginForm.valid) {
    this.loginForm.markAllAsTouched();
    return;
  }
  this.userDisabledEmitter.emit(false);
  // Capturar los valores ACÁ, antes de cualquier await: el template llama a
  // loginForm.reset() apenas se dispara este método (sincrónico), y con el captcha
  // de por medio el submit real puede tardar — para cuando le tocaba leer
  // this.loginForm.value más abajo, el form ya estaba vacío (contraseña "").
  const credentials = this.loginForm.value;

  // El widget de Turnstile vive dentro de *ngIf="!load": hay que pedir el token
  // ANTES de prender `load`, o el spinner lo saca del DOM justo cuando necesita mostrarse.
  if (this.turnstileEnabled && !this.turnstileToken) {
    try {
      this.turnstileToken = await this.requestTurnstileToken();
    } catch (error) {
      this.notificationService.error('No se pudo completar la verificación de seguridad, intentá nuevamente.');
      return;
    }
  }

  this.load = true;

  try {
    // 1. Cargar clave pública primero
    // await this._loginService.initializePublicKey();

    // 2. Proceder con login
    const response = await this._loginService.login(
      credentials,
      this.turnstileToken
    );

    if (response?.res === 1) {
      this.completeLogin(response);
    } else if (setting.twoFactorEnabled && response?.res === 2 && response?.pending_token) {
      // El usuario tiene 2FA activo: falta el segundo paso (código del authenticator).
      this.pendingToken = response.pending_token;
      this.twoFactorRequired = true;
      this.twoFactorError = false;
    } else {
      this.userDisabledEmitter.emit(true);
      this.openModalError();
    }
  } catch (error) {
    console.error('Login error:', error);

    const backendMsg = (error as HttpErrorResponse)?.error?.msg as string | undefined;
    const backendDet = (error as HttpErrorResponse)?.error?.det as string | undefined;

    if (backendMsg?.startsWith('CAPTCHA_')) {
      this.notificationService.error(backendDet || 'Hubo un problema con la verificación de seguridad, intentá de nuevo.');
    } else {
      this.openModalError();
    }
  } finally {
    this.load = false;
    this.resetTurnstile();
  }
}

private completeLogin(response?: any): void {
  // La sesión ya quedó en la cookie HttpOnly auth_token: el backend la setea
  // vía Set-Cookie en la respuesta del login, el browser la guarda solo
  // (el request se manda con withCredentials). No hay nada que hacer acá con el token.
  //
  // Modo legacy (setting.legacyAuthCookie): el backend de este entorno todavía
  // devuelve el token en el body en vez de setear la cookie, así que la escribe
  // el frontend acá mismo, como antes de "cookie security".
  if (setting.legacyAuthCookie && response?.token) {
    this._loginService.setCookie('auth_token', response.token, null, setting.c_domain, true);
  }

  const query = decodeURIComponent(
    this.activatedRoute.snapshot.queryParamMap.get('redirect') || ''
  );

  if (query && query !== "null" && this.isAllowedRedirect(query)) {
    window.location.href = query;
  } else {
    this._router.navigate(['/select', {}]);
  }
}

/**
 * El query param `redirect` lo arma código nuestro (los guards de Booking/Zoco/Abaco/
 * Backoffice te devuelven acá con `?redirect=<su propia URL>` para volver a mandarte
 * a donde ibas después del login) pero llega igual por la URL, así que cualquiera
 * puede pisarlo con `?redirect=https://sitio-falso.com`. Sin este chequeo, un login
 * legítimo terminaría mandando a la víctima a un dominio ajeno (open redirect).
 */
private isAllowedRedirect(url: string): boolean {
  const allowedUrls = [
    setting.appUrl,
    setting.appBookingUrl,
    setting.appZocoUrl,
    setting.appAbacoUrl,
    setting.appBookingBackoffice,
  ];
  try {
    const target = new URL(url, window.location.origin);
    const allowedOrigins = allowedUrls.map((u) => new URL(u).origin);
    return allowedOrigins.includes(target.origin);
  } catch {
    return false;
  }
}

async onVerifyTwoFactor(): Promise<void> {
  if (!this.pendingToken || !/^[0-9]{6}$/.test(this.twoFactorCode)) {
    this.twoFactorError = true;
    return;
  }

  this.load = true;
  this.twoFactorError = false;

  try {
    const response = await this._loginService.verifyTwoFactor(this.pendingToken, this.twoFactorCode);

    if (response?.res === 1) {
      this.completeLogin(response);
    } else {
      this.twoFactorError = true;
    }
  } catch (error) {
    console.error('2FA verification error:', error);
    this.twoFactorError = true;
  } finally {
    this.load = false;
  }
}

/** Vuelve al paso de email/contraseña; el pending_token queda invalidado del lado del backend por su propio TTL. */
cancelTwoFactor(): void {
  this.twoFactorRequired = false;
  this.twoFactorCode = '';
  this.twoFactorError = false;
  this.pendingToken = null;
}

/** Los tokens de Turnstile son de un solo uso; hay que pedir uno nuevo tras cada intento. */
private resetTurnstile(): void {
  this.turnstileToken = null;
  this.turnstile?.reset();
}

/** Dispara el challenge (invisible salvo que Cloudflare necesite interacción) y espera el token. */
private requestTurnstileToken(): Promise<string> {
  return new Promise((resolve, reject) => {
    this.turnstileResolve = resolve;
    this.turnstileReject = reject;
    this.turnstile?.execute();
  });
}

onTurnstileVerified(token: string): void {
  this.turnstileToken = token;
  this.turnstileResolve?.(token);
  this.turnstileResolve = null;
  this.turnstileReject = null;
}

onTurnstileExpired(): void {
  this.turnstileToken = null;
  this.turnstileReject?.(new Error('turnstile expired'));
  this.turnstileResolve = null;
  this.turnstileReject = null;
}

onTurnstileError(): void {
  this.turnstileToken = null;
  this.notificationService.error('No se pudo cargar la verificación de seguridad, recargue la página.');
  this.turnstileReject?.(new Error('turnstile error'));
  this.turnstileResolve = null;
  this.turnstileReject = null;
}

  openModalError() {
    this.loginShowModal.emit(true);
  }

  closeModal() {
    this.loginShowModal.emit(false);
  }

  confirmAction() {
    this.closeModal();
  }

	initUser() {

		// La sesión vive en la cookie HttpOnly auth_token, que el JS no puede leer:
		// en vez de chequearla, se le pregunta al backend si ya hay una sesión válida.
		this._loginService.getCurrent().subscribe({
			next: (data: any) => {
				if (data.res == 1) { // ya hay sesión -> redirige a select
					this._router.navigate(['/select', {}]);
				}
			},
			error: () => {} // sin sesión, se queda en el login
		});
	}

	callRecoverForm(action: string){
    if(action === 'user') {
      this.actionRecover = 'usuario';
    } else if(action === 'password') {
      this.actionRecover = 'contraseña';
    }
		this.activeform.login = false;
	}

	callLoginForm(){
    this.loadingResetPass = true;
		this.activeform.login = true;
	}

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }


  loadResetPass() {
    this.loadingResetPass = !this.loadingResetPass;
    this.activeform.login = false;
  }

}
